var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoordinationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 56,
    viewBox: "0 0 80 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5976",
    "data-name": "Rectangle 5976",
    width: 80,
    height: 56,
    fill: "#77191a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10781",
    "data-name": "Group 10781",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10780",
    "data-name": "Group 10780",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30835",
    "data-name": "Path 30835",
    d: "M33.05,18.405l-1.732-.43a13.55,13.55,0,0,0-.693-4.6l1.532-.924a3,3,0,0,0-3.1-5.143l-1.532.923a13.544,13.544,0,0,0-3.742-2.765l.43-1.735a3,3,0,1,0-5.823-1.452v.006l-.43,1.735a13.573,13.573,0,0,0-4.6.693l-.921-1.532A3,3,0,0,0,7.3,6.276l.926,1.532a13.532,13.532,0,0,0-2.766,3.745l-1.738-.432a3,3,0,0,0-1.445,5.826l1.734.431a13.587,13.587,0,0,0,.693,4.6L3.173,22.9a3,3,0,0,0,3.1,5.143L7.8,27.122a13.519,13.519,0,0,0,3.742,2.767l-.431,1.735a3,3,0,1,0,5.823,1.452V33.07l.43-1.734a13.587,13.587,0,0,0,4.6-.695l.923,1.533a3,3,0,0,0,5.142-3.1l-.923-1.531A13.592,13.592,0,0,0,29.872,23.8l1.733.43a3,3,0,0,0,1.445-5.826M16.026,24.281a6.807,6.807,0,1,1,8.245-4.966v0a6.8,6.8,0,0,1-8.242,4.964h0",
    transform: "translate(0 0)",
    fill: "#77191a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30836",
    "data-name": "Path 30836",
    d: "M93.192,29.966H90.713a18.829,18.829,0,0,0-2.473-5.973L90,22.235a4.17,4.17,0,0,0-5.895-5.9L82.344,18.1a18.827,18.827,0,0,0-5.97-2.475V13.137a4.168,4.168,0,1,0-8.336-.008V15.62a18.863,18.863,0,0,0-5.97,2.475l-1.755-1.758a4.17,4.17,0,0,0-5.9,5.9l1.761,1.755A18.819,18.819,0,0,0,53.7,29.965H51.215a4.169,4.169,0,0,0,0,8.338H53.7a18.864,18.864,0,0,0,2.473,5.973l-1.755,1.755a4.17,4.17,0,0,0,5.9,5.9l1.755-1.758a18.818,18.818,0,0,0,5.97,2.477v2.483a4.168,4.168,0,1,0,8.336.008v-2.49a18.868,18.868,0,0,0,5.97-2.477L84.1,51.93a4.17,4.17,0,0,0,5.9-5.9l-1.757-1.755A18.864,18.864,0,0,0,90.711,38.3h2.48a4.169,4.169,0,0,0,0-8.338M72.206,43.587a9.456,9.456,0,1,1,9.453-9.454v0a9.451,9.451,0,0,1-9.451,9.452h0",
    transform: "translate(-17.355 -3.304)",
    fill: "#77191a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoordinationIcon);
export default __webpack_public_path__ + "static/media/CoordinationIcon.d4b04542d10cda7d67bf73b30b0feb2c.svg";
export { ForwardRef as ReactComponent };